export class TableFeatureFlag {
    constructor(flag) {
        this.FlagName = flag.FeatureFlagName;
        this.ServiceName = flag.ServiceName;
        this.EnabledForAll = flag.enabledFor["enabledForAll"];
        this.EnabledForList = flag.enabledFor["enabledForList"];
        this.EnabledForListType = flag.enabledFor["enabledForListType"];
        this.FlagDescription = flag.featureFlagDescription;
        this.TimestampUTC = flag.timestamp
    }
}